// components/PageSkeleton.jsx — Loading skeleton for initial Firebase fetch
export default function PageSkeleton({ dark }) {
  const base = dark ? "bg-white/8" : "bg-[#0F172A]/8";
  const shimmer = dark
    ? "before:bg-gradient-to-r before:from-transparent before:via-white/10 before:to-transparent"
    : "before:bg-gradient-to-r before:from-transparent before:via-[#0F172A]/8 before:to-transparent";

  const Bone = ({ className }) => (
    <div
      className={`rounded-xl relative overflow-hidden ${base} ${className}`}
      style={{
        backgroundImage: dark
          ? "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.07) 50%, transparent 100%)"
          : "linear-gradient(90deg, transparent 0%, rgba(15,23,42,0.06) 50%, transparent 100%)",
        backgroundSize: "200% 100%",
        animation: "skeleton-shimmer 1.6s ease-in-out infinite",
      }}
    />
  );

  return (
    <div className={`min-h-screen ${dark ? "bg-[#0F172A]" : "bg-white"}`}>
      <style>{`
        @keyframes skeleton-shimmer {
          0%   { background-position: -200% 0; }
          100% { background-position:  200% 0; }
        }
      `}</style>

      {/* Navbar skeleton */}
      <div className={`h-16 border-b flex items-center px-8 gap-6 ${dark ? "border-white/10" : "border-[#E2E8F0]"}`}>
        <Bone className="h-8 w-28" />
        <div className="flex-1" />
        <Bone className="h-5 w-16 hidden sm:block" />
        <Bone className="h-5 w-16 hidden sm:block" />
        <Bone className="h-5 w-16 hidden sm:block" />
        <Bone className="h-9 w-28 rounded-xl" />
      </div>

      {/* Hero skeleton */}
      <div className="px-6 py-24 max-w-4xl mx-auto flex flex-col items-center gap-6">
        <Bone className="h-5 w-32" />
        <Bone className="h-14 w-full max-w-2xl" />
        <Bone className="h-14 w-3/4 max-w-xl" />
        <Bone className="h-5 w-full max-w-lg" />
        <Bone className="h-5 w-2/3 max-w-md" />
        <div className="flex gap-4 mt-4">
          <Bone className="h-12 w-36 rounded-2xl" />
          <Bone className="h-12 w-36 rounded-2xl" />
        </div>
      </div>

      {/* Services skeleton */}
      <div className={`px-6 py-20 ${dark ? "bg-white/[0.02]" : "bg-[#F8FAFC]"}`}>
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col items-center gap-3 mb-12">
            <Bone className="h-10 w-48" />
            <Bone className="h-5 w-72" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {[...Array(6)].map((_, i) => (
              <div key={i} className={`rounded-2xl p-6 border ${dark ? "border-white/10" : "border-[#E2E8F0]"}`}>
                <Bone className="h-12 w-12 rounded-xl mb-5" />
                <Bone className="h-5 w-3/4 mb-3" />
                <Bone className="h-4 w-full mb-2" />
                <Bone className="h-4 w-5/6 mb-2" />
                <Bone className="h-4 w-4/6" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Portfolio skeleton */}
      <div className="px-6 py-20 max-w-5xl mx-auto">
        <div className="flex flex-col items-center gap-3 mb-12">
          <Bone className="h-10 w-36" />
          <Bone className="h-5 w-64" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {[...Array(3)].map((_, i) => (
            <div key={i} className={`rounded-2xl overflow-hidden border ${dark ? "border-white/10" : "border-[#E2E8F0]"}`}>
              <Bone className="h-48 w-full rounded-none" />
              <div className="p-5 flex flex-col gap-3">
                <Bone className="h-5 w-3/4" />
                <Bone className="h-4 w-1/2" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
